import axiosInstance from "../../axios/axios";

export const createOrEditLeaseApi = (payload) => {
    const formData = new FormData();
    for (const key in payload) {
        if (payload[key] !== null && payload[key] !== undefined) {
            formData.append(key, payload[key]);
        }
    }
    return axiosInstance.post("/HorseLeasing/CreateOrEdit", formData, {
        headers: { "Content-Type": "multipart/form-data" }
    });
};

export const approveRejectLeaseApi = (payload) => {
    return axiosInstance.post("/HorseLeasing/ApproveReject", payload);
};

